export default "__VITE_PUBLIC_ASSET__62eaa20d__"